import { render } from "./blog_detail.vue?vue&type=template&id=fbc6cac2&scoped=true"
import script from "./blog_detail.vue?vue&type=script&lang=js"
export * from "./blog_detail.vue?vue&type=script&lang=js"

import "./blog_detail.vue?vue&type=style&index=0&id=fbc6cac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc6cac2"]])

export default __exports__